import { DeploymentHostType } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { REFERRAL_INFO, ROUTES } from '../constants/routes';
import { QueryParams } from '../constants/QueryParams';
import { useQueryParam } from './useQueryParam';
import { useSelfHostedContext } from '../components/TemplatePage/Modals/SelfHostedModal/SelfHostedModalContextProvider';
import { useEffect } from 'react';

export const useLoginSelfHostedModal = (
  selectedProvider: DeploymentHostType,
) => {
  const { getParam, removeParam } = useQueryParam();
  const { updateSelectedDeploymentProvider } = useSelfHostedContext();

  useEffect(() => {
    const selectedProvider = getParam(
      QueryParams.SELECTED_PROVIDER,
    ) as DeploymentHostType;
    if (selectedProvider && DeploymentHostType[selectedProvider]) {
      updateSelectedDeploymentProvider(selectedProvider);
      removeParam(QueryParams.SELECTED_PROVIDER);
    }
  }, [getParam, removeParam, updateSelectedDeploymentProvider]);

  const currentUrl = window.location.href;
  const returnedUrl = encodeURIComponent(
    `${currentUrl}&${QueryParams.SELECTED_PROVIDER}=${selectedProvider}`,
  );
  return () => {
    window.location.assign(
      ROUTES.loginPage(returnedUrl, REFERRAL_INFO.SELF_HOSTED_MODAL),
    );
  };
};
